
export const setKpiData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({type:"Set_Kpi_Data", payload})
    } catch (error) {
      console.log(error)
    }
  };
};

export const setKpiData2 = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({type:"Set_Kpi_Data2", payload})
    } catch (error) {
      console.log(error)
    }
  };
};

export const setWeekData = (payload) => {
    return async (dispatch) => {
      try {
        dispatch({type:"Set_week_days", payload})
      } catch (error) {
        console.log(error)
      }
    };
  };
export const setStoreData = (payload) => {
    return async (dispatch) => {
      try {
        dispatch({type:"Set_store_data", payload})
      } catch (error) {
        console.log(error)
      }
    };
  };
  export const setCalenderData = (payload) => {
    return async (dispatch) => {
      try {
        dispatch({ type: "Set_calender_data", payload });
      } catch (error) {
        console.log(error);
      }
    };
  };